import { render, staticRenderFns } from "./PopupCreateCompany.vue?vue&type=template&id=be014cf2&scoped=true&"
import script from "./PopupCreateCompany.vue?vue&type=script&lang=js&"
export * from "./PopupCreateCompany.vue?vue&type=script&lang=js&"
import style0 from "./PopupCreateCompany.vue?vue&type=style&index=0&id=be014cf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be014cf2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VRow,VTextField})
